import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContentText, DialogTitle } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';

import Button from '../../../modules/Button/Button';
import '../SupplierDataChangeTranslate';

export default function AnnulNotificationModal({
  open,
  onClose,
  onConfirm,
  loading = false
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="annul-dialog-title"
      aria-describedby="annul-dialog-description"
    >
      <DialogTitle id="annul-dialog-title">{t('supplierDataChange_annulTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="annul-dialog-description">
          {t('supplierDataChange_annulBody')}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ textAlign: 'center' }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          text={t('supplierDataChange_cancel')}
        />
        <Button
          onClick={onConfirm}
          color="secondary"
          variant="contained"
          loading={loading}
          text={t('supplierDataChange_confirm')}
        />
      </DialogActions>
    </Dialog>
  );
}
